import { configureStore } from "@reduxjs/toolkit";
import { balanceStoreName, balanceReducer } from "./balance";
import { cardStoreName, cardReducer } from "./card";
import { packagesStoreName, packagesReducer } from "./packages";
import { newsStoreName, newsReducer } from "./news";

export const store = configureStore({
  reducer: {
    [balanceStoreName]: balanceReducer,
    [cardStoreName]: cardReducer,
    [packagesStoreName]: packagesReducer,
    [newsStoreName]: newsReducer,
  },
});
